// The fal-key (BYOK) plans: one list for /pricing, the plan comparison table, /select-plan and /bar.
// Plain data (no 'use client'), so server components can read it too.

export interface ByokPlan {
  name: string
  price: string
  /** Per month when billed for the year; absent on plans with nothing to discount. */
  annual?: string
  /** Olives a month, for models not on fal. Absent = top-ups only. */
  olives?: string
  /** Launch (founding) price per month: [monthly, annual]. Read it through launchOffer.ts. */
  founding?: [string, string]
  tagline: string
  /** Processing minutes a month. */
  processingMinutes: string
  features: string[]
  /** "Everything in X, plus" on the paid cards. */
  includes?: string
  cta: string
  /** 30-day free trial, card up front. */
  trial?: boolean
  highlighted?: boolean
}

export const BYOK_PLANS: ByokPlan[] = [
  {
    name: 'Free',
    price: '$0',
    tagline: 'For trying Martini',
    processingMinutes: '150',
    features: ['Your fal key', 'MCP, CLI and API', 'Share links and XML export', 'Public projects'],
    cta: 'Get started',
  },
  {
    name: 'Pro',
    price: '$45',
    annual: '$35',
    founding: ['$25', '$15'],
    olives: '50',
    tagline: 'For professionals and freelancers',
    processingMinutes: '1,500',
    includes: 'Everything in Free, plus',
    features: ['Private projects', 'Early access to new features'],
    cta: 'Start free trial',
    trial: true,
    highlighted: true,
  },
  {
    name: 'Studio',
    price: '$245',
    annual: '$195',
    founding: ['$125', '$95'],
    olives: '250',
    tagline: 'For studios and production teams',
    processingMinutes: '15,000',
    includes: 'Everything in Pro, plus',
    features: ['Team workspace', 'Team and permissions', 'Estimated fal spend per project'],
    cta: 'Start free trial',
    trial: true,
  },
]

// Shown as the fourth card, mirroring the standard plans. Kept out of BYOK_PLANS, which the
// comparison table reads as the three self-serve plans.
export const BYOK_ENTERPRISE: ByokPlan = {
  name: 'Enterprise',
  price: 'Custom',
  tagline: 'For bespoke solutions',
  olives: 'Custom',
  processingMinutes: 'Custom',
  includes: 'Everything in Studio, plus',
  features: ['SSO', 'Billing access for finance', 'SLAs and integrations', 'Hands-on production support'],
  cta: 'Contact sales',
}
